import gql from "graphql-tag";

export const GET_REFBESLOOKUP = gql`
	query refBesLookup(
		$skip: Int
		$take: Int
		$where: RefBesFilterInput
		$order: [RefBesSortInput!]
		$labelId: String!, 
		$activeOnly: Boolean) { 
    refBesLookup(
    	skip: $skip
		take: $take
		where: $where
		order: $order
		labelId: $labelId,
        activeOnly: $activeOnly
    ) 
    {
    pageInfo{
        hasNextPage,
        hasPreviousPage
      },
        items {
            key,
            omschrijving,
            actief
        }
    }
}
`;
